import { z } from 'zod';

/**
 * Binding agenti AI ↔ tool MCP / workflow (`/api/mcp/agent-permissions*`,
 * `/api/mcp/agent-workflows*`, pannello "Agent Bindings").
 * Source of truth: `packages/backend/src/routes/api-v2/mcp.routes.ts`.
 *
 * Le liste rispondono con envelope `{ success, data }`; le mutazioni batch e
 * copy rispondono TOP-LEVEL (`{ success, updated }`, `{ success, copied }`) e
 * il refresh dei tool con `{ success, agent_type, actions, tools_count }`.
 */

export const mcpAgentPermissionSchema = z
  .object({
    id: z.string().optional(),
    agent_id: z.string(),
    server_id: z.string(),
    tool_name: z.string(),
    tool_type: z.string(),
    enabled: z.boolean(),
    bulk_allowed: z.boolean().nullable().optional(),
  })
  .passthrough();
export type McpAgentPermission = z.infer<typeof mcpAgentPermissionSchema>;

export const mcpAgentWorkflowBindingSchema = z
  .object({
    id: z.string(),
    workflow_id: z.string(),
    agent_id: z.string(),
    enabled: z.boolean(),
    workflow_name: z.string(),
    description: z.string().nullable().optional(),
    trigger_type: z.string(),
    workflow_active: z.boolean(),
  })
  .passthrough();
export type McpAgentWorkflowBinding = z.infer<typeof mcpAgentWorkflowBindingSchema>;

export const mcpBatchUpdateResponseSchema = z.object({ success: z.literal(true), updated: z.number() });
export type McpBatchUpdateResponse = z.infer<typeof mcpBatchUpdateResponseSchema>;

export const mcpCopyBindingsResponseSchema = z.object({ success: z.literal(true), copied: z.number() });
export type McpCopyBindingsResponse = z.infer<typeof mcpCopyBindingsResponseSchema>;

export const mcpRefreshAgentToolsResponseSchema = z.object({
  success: z.literal(true),
  agent_type: z.string(),
  actions: z.array(z.string()),
  tools_count: z.number(),
});
export type McpRefreshAgentToolsResponse = z.infer<typeof mcpRefreshAgentToolsResponseSchema>;

/** `POST /elevenlabs/agents/:id/sync-tools` → `data: { synced }`. */
export const elevenLabsSyncToolsDataSchema = z.object({ synced: z.number() });
export type ElevenLabsSyncToolsData = z.infer<typeof elevenLabsSyncToolsDataSchema>;
